import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, isEmpty } from "lodash";

import Tabs from "@material-ui/core/Tabs";

import CustomTab from "../../Common/CustomTab";

import { driveInOut, walkInOut } from "../../../constants/reducers";
import {
  logDetailsTabs as tabs,
  human,
  truck,
  trailer,
} from "../../../constants/common";

import images from "../../../assets/img/images";

const styles = {
  tabs: {
    height: "40px",
    float: "left",
    minHeight: "40px",
  },
  icon: {
    height: "17px",
    maxWidth: "30px",
    paddingRight: "5px",
  },
};

const LogDetailsTabs = (props) => {
  const { classes, activeTab, changeTab, section, overriden } = props;

  return (
    <Tabs
      value={activeTab}
      onChange={(e, v) => changeTab(v)}
      indicatorColor="primary"
      centered
      className={classes.tabs}
    >
      <CustomTab
        height="40px"
        label={I18n.get("site_summary")}
        value={tabs.summary}
      />
      <CustomTab
        height="40px"
        label={I18n.get("site_human")}
        value={tabs.human}
        icon={
          <img
            src={images.humanIconBlack}
            className={classes.icon}
            alt="icon"
          />
        }
        overridenIcon={!isEmpty(get(overriden, [human]))}
      />
      {section === driveInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_truck")}
          value={tabs.vehicle}
          icon={
            <img
              src={images.truckIconBlack}
              className={classes.icon}
              alt="icon"
            />
          }
          overridenIcon={!isEmpty(get(overriden, [truck]))}
        />
      )}
      {section === driveInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_trailer")}
          value={tabs.trailer}
          icon={
            <img
              src={images.trailerIconBlack}
              className={classes.icon}
              alt="icon"
            />
          }
          overridenIcon={!isEmpty(get(overriden, [trailer]))}
        />
      )}
      {section === walkInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_verification")}
          value={tabs.verification}
        />
      )}
      {section === walkInOut && (
        <CustomTab
          height="40px"
          label={I18n.get("site_temperatures")}
          value={tabs.temperature}
        />
      )}
      <CustomTab
        height="40px"
        //label={`${I18n.get("site_notes")} (${this.getNotesCount()})`}
        label={`${I18n.get("site_notes")}`}
        value={tabs.notes}
      />
    </Tabs>
  );
};
export default withStyles(styles)(LogDetailsTabs);
